/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '../../../atoms/link/css/link';
import '../../../atoms/button/css/button';
import '../../../atoms/heading/css/heading';
import '../../../atoms/svg/css/svg';
import '../../../atoms/button/css/button';
import '../../../molecules/form-actions/css/form-actions';

import '../elements/overlay-header/css/overlay-header';
import '../elements/overlay-content/css/overlay-content';
import '../elements/overlay-footer/css/overlay-footer';
import './overlay.scss';
import './modifier/minimal.scss';
import './modifier/meta-navigation.scss';
import './modifier/profile.scss';
import './modifier/search-navigation.scss';
import './modifier/transition-group.scss';
import './modifier/cms.scss';
import './modifier/form.scss';
